/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DestroyRef, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import {SignalPageState} from '../common/controller/signal-page-state';
import template from './political-entity-campaigns-panel.component.html';
import {AppSharedModule} from '../common/app-shared.module';
import {formatAdnStat} from '../common/filters/format-adn-stat';
import {AppLocaleService} from '../common/locale/app-locale.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {PoliticalCampaignApiService} from '../political-campaign/political-campaign-api.service';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule],
  selector: 'adn-political-entity-campaigns-panel',
  template
})
export class PoliticalEntityCampaignsPanelComponent implements OnInit, OnChanges {
  @Input() model: any;
  @Input() isNew: boolean;

  effectiveIsNew = false;
  readonly campaigns: SignalPageState<any, string>;

  constructor(
    private readonly politicalCampaignApi: PoliticalCampaignApiService,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService,
    private readonly destroyRef: DestroyRef
  ) {
    this.campaigns = new SignalPageState((id) => this.politicalCampaignApi.listForEntity(id), 25, destroyRef);
  }

  ngOnInit(): void {
    this.effectiveIsNew = !!this.isNew;
    this.tryLoadCampaigns();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if ((changes.model && !changes.model.firstChange) || (changes.isNew && !changes.isNew.firstChange)) {
      this.tryLoadCampaigns();
    }
  }

  formatStat(value: any): string {
    return formatAdnStat(value, undefined, undefined, undefined, this.LocalNetworkProfile.get('defaultCurrency'), this.appLocale.getLocaleId());
  }

  trackById(_: number, item: any): string {
    return item.id;
  }

  private tryLoadCampaigns(): void {
    if (!this.effectiveIsNew && this.model?.id) {
      this.loadCampaigns(this.model.id);
    } else {
      this.campaigns.clear();
    }
  }

  private loadCampaigns(entityId: string): void {
    this.campaigns.load(entityId, true);
  }
}
